import { ColorValue, StyleSheet } from "react-native";
import { Colors } from "./ColorConfig";

export const TypographyStyles = StyleSheet.create({
  heading1: {
    fontSize: 40,
    letterSpacing: 0.4,
    fontFamily: "EBGaramondBold",
    color: "#000",
  },
  heading2: {
    fontSize: 32,
    letterSpacing: 0.4,
    fontFamily: "EBGaramondBold",
    color: "#000",
  },
  heading3: {
    fontSize: 24,
    letterSpacing: 0.4,
    fontFamily: "EBGaramondBold",
    color: "#000",
  },
  heading3SemiBold: {
    fontSize: 24,
    letterSpacing: 0.4,
    fontFamily: "EBGaramondSemiBold",
    color: "#000",
  },
  title1: {
    fontSize: 20,
    letterSpacing: 0.2,
    fontFamily: "EBGaramondBold",
    color: "#000",
  },
  title2: {
    fontSize: 18,
    letterSpacing: 0.18,
    fontFamily: "InterRegular",
    color: "#000",
  },
  title3: {
    fontSize: 16,
    letterSpacing: 0.16,
    fontFamily: "InterRegular",
    color: "#000",
  },
  bodyText: {
    fontSize: 16,
    letterSpacing: 0.16,
    fontFamily: "InterRegular",
    color: "#000",
  },
  bodyTextBold: {
    fontSize: 16,
    letterSpacing: 0.16,
    fontFamily: "InterBold",
    color: "#000",
  },
  ctaText: {
    fontSize: 16,
    letterSpacing: 0.16,
    fontFamily: "InterMedium",
    color: "#000",
  },
  captionText: {
    fontFamily: "InterRegular",
    fontSize: 14,
    letterSpacing: 0.1,
    color: "#000",
  },
  rescheduleBookings: {
    fontSize: 16,
    letterSpacing: 0.16,
    fontFamily: "InterRegular",
    color: Colors.white10 as ColorValue,
  },
  cancellationPolicy: {
    fontSize: 20,
    letterSpacing: 0.4,
    fontFamily: "EBGaramondBold",
    color: Colors.black90 as ColorValue,
  },
  tabTextLight: {
    fontSize: 16,
    letterSpacing: 0.16,
    fontFamily: "InterRegular",
    color: Colors.black30 as ColorValue,
  },
  tabTextDark: {
    fontSize: 16,
    letterSpacing: 0.16,
    fontFamily: "InterRegular",
    color: Colors.black100 as ColorValue,
  },
});
